"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListboxGroupLabelMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _ListboxOptionMedia = require("../../components/ListboxOptionMedia/ListboxOptionMedia.styles");
var _typographyMixin = require("../typographyMixin");
var _ListboxOptionMixin = require("./ListboxOptionMixin");
var _VisuallyHiddenMixin = require("./VisuallyHiddenMixin");
var ListboxGroupLabelMixin = function ListboxGroupLabelMixin(props) {
  return (0, _styledToken.default)({
    fontType: 'ListboxGroupLabel.fontType',
    fontColor: 'ListboxGroupLabel.fontColor',
    backgroundColor: 'ListboxGroupLabel.backgroundColor',
    textTransform: 'ListboxGroupLabel.textTransform'
  }, function (_ref) {
    var fontType = _ref.fontType,
      fontColor = _ref.fontColor,
      backgroundColor = _ref.backgroundColor,
      _ref$textTransform = _ref.textTransform,
      textTransform = _ref$textTransform === void 0 ? 'uppercase' : _ref$textTransform;
    return (0, _styledComponents.css)(["", " ", " cursor:default;text-transform:", ";background-color:", ";&,", "{color:", ";}", ""], (0, _ListboxOptionMixin.ListboxOptionMixin)(props), (0, _typographyMixin.typographyMixin)(Object.assign({
      fontType: fontType
    }, props)), textTransform, backgroundColor, _ListboxOptionMedia.StyledListboxOptionMedia, fontColor, props.visuallyHidden ? (0, _VisuallyHiddenMixin.VisuallyHiddenMixin)(props) : '');
  })(props);
};
exports.ListboxGroupLabelMixin = ListboxGroupLabelMixin;